import { computed, watch, type Ref, type WritableComputedRef } from 'vue'

interface RentForm {
  actual_rent_living: number | null
  actual_rent_business: number | null
  expected_rent_living: number | null
  expected_rent_business: number | null
}

/**
 * The rent is stored per usage and summed into `actual_rent` when the property is saved, so the
 * single field the wizard asks for writes to the side the property type allows.
 */
export function usePropertyRents(
  form: RentForm,
  hasLivingSpace: Ref<boolean>,
): { actualRent: WritableComputedRef<number | null>; expectedRent: WritableComputedRef<number | null> } {
  watch(hasLivingSpace, (livingSpace) => {
    if (livingSpace) {
      form.actual_rent_business = null
      form.expected_rent_business = null
    } else {
      form.actual_rent_living = null
      form.expected_rent_living = null
    }
  })

  return {
    actualRent: computed({
      get: () => (hasLivingSpace.value ? form.actual_rent_living : form.actual_rent_business),
      set: (value) => {
        if (hasLivingSpace.value) {
          form.actual_rent_living = value
        } else {
          form.actual_rent_business = value
        }
      },
    }),
    expectedRent: computed({
      get: () => (hasLivingSpace.value ? form.expected_rent_living : form.expected_rent_business),
      set: (value) => {
        if (hasLivingSpace.value) {
          form.expected_rent_living = value
        } else {
          form.expected_rent_business = value
        }
      },
    }),
  }
}
